export const PASSWORD_COMPLEXITY_PATTERN =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d]).+$/;

export const SA_ID_NUMBER_DIGITS_PATTERN = /^\d{13}$/;

export const SA_PHONE_NUMBER_PATTERN = /^(0\d{9}|\+27\d{9})$/;

export const TIME_24H_PATTERN = /^([01]\d|2[0-3]):[0-5]\d$/;

export const LOOSE_TIME_PATTERN = /^\d{2}:\d{2}$/;

export const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const EMIS_NUMBER_PATTERN = /^\d{8}$/;

export const CONTENT_DISPOSITION_FILENAME_PATTERN = /filename="?([^";\n]+)"?/i;

export const NON_DIGIT_PATTERN = /\D/g;

export const WHITESPACE_PATTERN = /\s/g;

export const UNDERSCORE_PATTERN = /_/g;

export const DOUBLE_QUOTE_PATTERN = /"/g;

export const UUID_TEMPLATE_CHAR_PATTERN = /[xy]/g;

export const HTML_AMPERSAND_PATTERN = /&/g;

export const HTML_LESS_THAN_PATTERN = /</g;

export const HTML_GREATER_THAN_PATTERN = />/g;

export const HTML_DOUBLE_QUOTE_PATTERN = /"/g;

export const HTML_SINGLE_QUOTE_PATTERN = /'/g;
